/* Asse selezionato
null | {"value": axis, ...}
*/
import { createContext } from "react";
const SelectedAxisContext = createContext({
    selectedAxis: null,
    setSelectedAxis: (axis) => {}
  });
export default SelectedAxisContext;